import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'numberFormat'
})
export class NumberFormat implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if (value !== null && value !== undefined) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    else {
        return value;
    }
  }
}
